/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  APIMaterial,
  APIMaterialRequest,
  APIPaginatedMaterialList,
  APIPatchedMaterialRequest,
} from '../models/index';
import {
    APIMaterialFromJSON,
    APIMaterialToJSON,
    APIMaterialRequestFromJSON,
    APIMaterialRequestToJSON,
    APIPaginatedMaterialListFromJSON,
    APIPaginatedMaterialListToJSON,
    APIPatchedMaterialRequestFromJSON,
    APIPatchedMaterialRequestToJSON,
} from '../models/index';

export interface V1ItemsMaterialsCreateRequest {
    aPIMaterialRequest: APIMaterialRequest;
}

export interface V1ItemsMaterialsDestroyRequest {
    id: number;
}

export interface V1ItemsMaterialsListRequest {
    page?: number;
    pageSize?: number;
}

export interface V1ItemsMaterialsPartialUpdateRequest {
    id: number;
    aPIPatchedMaterialRequest?: APIPatchedMaterialRequest;
}

export interface V1ItemsMaterialsRetrieveRequest {
    id: number;
}

export interface V1ItemsMaterialsUpdateRequest {
    id: number;
    aPIMaterialRequest: APIMaterialRequest;
}

/**
 * 
 */
export class ItemsmaterialsApi extends runtime.BaseAPI {

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsMaterialsCreateRaw(requestParameters: V1ItemsMaterialsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIMaterial>> {
        if (requestParameters['aPIMaterialRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIMaterialRequest',
                'Required parameter "aPIMaterialRequest" was null or undefined when calling v1ItemsMaterialsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/materials/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APIMaterialRequestToJSON(requestParameters['aPIMaterialRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIMaterialFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsMaterialsCreate(requestParameters: V1ItemsMaterialsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIMaterial> {
        const response = await this.v1ItemsMaterialsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsMaterialsDestroyRaw(requestParameters: V1ItemsMaterialsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsMaterialsDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/materials/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsMaterialsDestroy(requestParameters: V1ItemsMaterialsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.v1ItemsMaterialsDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsMaterialsListRaw(requestParameters: V1ItemsMaterialsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIPaginatedMaterialList>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/materials/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIPaginatedMaterialListFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsMaterialsList(requestParameters: V1ItemsMaterialsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIPaginatedMaterialList> {
        const response = await this.v1ItemsMaterialsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsMaterialsPartialUpdateRaw(requestParameters: V1ItemsMaterialsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIMaterial>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsMaterialsPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/materials/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: APIPatchedMaterialRequestToJSON(requestParameters['aPIPatchedMaterialRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIMaterialFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsMaterialsPartialUpdate(requestParameters: V1ItemsMaterialsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIMaterial> {
        const response = await this.v1ItemsMaterialsPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsMaterialsRetrieveRaw(requestParameters: V1ItemsMaterialsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIMaterial>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsMaterialsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/materials/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIMaterialFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsMaterialsRetrieve(requestParameters: V1ItemsMaterialsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIMaterial> {
        const response = await this.v1ItemsMaterialsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsMaterialsUpdateRaw(requestParameters: V1ItemsMaterialsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIMaterial>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsMaterialsUpdate().'
            );
        }

        if (requestParameters['aPIMaterialRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIMaterialRequest',
                'Required parameter "aPIMaterialRequest" was null or undefined when calling v1ItemsMaterialsUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/materials/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: APIMaterialRequestToJSON(requestParameters['aPIMaterialRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIMaterialFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsMaterialsUpdate(requestParameters: V1ItemsMaterialsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIMaterial> {
        const response = await this.v1ItemsMaterialsUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
